import styled from 'styled-components';

import { Checkbox } from '@dreryk/react-components';

export const StyledAllDaysPreferencesField = styled(Checkbox)`
   margin-right: auto;
`;
